'use strict';

exports.__esModule = true;
exports['default'] = defaultProps;

var _validators = require('../../utils/validators');

function defaultProps(props) {
  return function (target) {
    (0, _validators.validateClass)(target, 'defaultProps');

    // eslint-disable-next-line
    target.defaultProps = props;
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/components/defaultProps.js
// module id = 547
// module chunks = 1